import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'politica-privacidad',
  templateUrl: './politica-privacidad.component.html',
  styleUrls: ['./politica-privacidad.component.css']
})
export class PoliticaPrivacidadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
